import ApplicationHeading from '@/components/Elements/Heading/ApplicationHeading';
import { Card, Typography } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

interface MeetingProps {
  meetingUrl: string;
  title?: string;
}

const Meeting: React.FC<MeetingProps> = ({ meetingUrl, title }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = '';
    }

    const script = document.createElement('script');
    script.src =
      'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';
    script.async = true;

    const meetingDiv = document.createElement('div');
    meetingDiv.className = 'meetings-iframe-container';
    meetingDiv.setAttribute('data-src', meetingUrl);
    meetingDiv.style.backgroundColor = 'white';

    containerRef.current?.appendChild(meetingDiv);
    document.body.appendChild(script);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        const iframeAdded = Array.from(mutation.addedNodes).some(
          (node) => (node as HTMLElement).tagName === 'IFRAME',
        );
        if (iframeAdded) {
          setLoaded(true);
          observer.disconnect();
          break;
        }
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current, {
        childList: true,
        subtree: true,
      });
    }

    return () => {
      document.body.removeChild(script);
      observer.disconnect();
    };
  }, [meetingUrl]);

  return (
    <Card
      /* {title && <ApplicationHeading title={title} />} */
      title={
        title && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography.Title
              level={4}
              style={{
                margin: 0,
              }}
            >
              {title}
            </Typography.Title>
          </div>
        )
      }
    >
      {!loaded && (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <Typography.Text>Loading...</Typography.Text>
        </div>
      )}
      {meetingUrl && (
        <div
          ref={containerRef}
          style={{
            visibility: loaded ? 'visible' : 'hidden',
            minHeight: '400px',
          }}
        ></div>
      )}
    </Card>
  );
};

export default Meeting;
